<template>
    <div class="content content--registration">
        <div class="small-window">
            <div class="form-wrap">
                <h1 class="form-wrap__title form-wrap__title--purpose form-wrap__title--sticky">Укажите цель  получения микрокредита</h1>

                <div class="form-wrap__row" >
                    <c-radio-group v-model="purpose" :valueList="purposeList" :label="'Цель займа'" :fieldName="'purpose'"></c-radio-group>
                </div>

                <div class="form-wrap__row">
                    <div class="form-button__wrap">
                        <button @click="makeCredit" class="form-button form-button--violet">
                            Продолжить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {createHelpers} from 'vuex-map-fields';
    import productAdapter from '@/modules/productAdapter'
    import Helpers from '@/modules/Helpers';
    import moment from 'moment';
    import 'moment/locale/ru';
    import Raven from 'raven-js'

    const {mapFields: calculatorFields} = createHelpers({
        getterType: 'calculator/getField',
        mutationType: 'calculator/updateField',
    });
    const {mapFields: creditFields} = createHelpers({
        getterType: 'credit/getField',
        mutationType: 'credit/updateField',
    });


    export default {
        name: 'Purpose',
        data() {
            return {
                purposeList: [
                    {
                        label: 'Оплата за обучение',
                        value: 'Оплата за обучение'
                    },
                    {
                        label: 'Ремонт и строительство',
                        value: 'Ремонт и строительство'
                    },
                    {
                        label: 'Приобретение электронной техники',
                        value: 'Приобретение электронной техники'
                    },
                    {
                        label: 'Приобретение земельного участка',
                        value: 'Приобретение земельного участка'
                    },
                    {
                        label: 'Медицинские услуги',
                        value: 'Медицинские услуги'
                    },
                    {
                        label: 'Ремонт/приобретение мебели',
                        value: 'Ремонт/приобретение мебели'
                    },
                    {
                        label: 'Ремонт/приобретение автомобиля',
                        value: 'Ремонт/приобретение автомобиля'
                    },
                    {
                        label: 'Рефинансирование микрокредита',
                        value: 'Рефинансирование микрокредита'
                    },
                    {
                        label: 'Проведение торжественных мероприятий',
                        value: 'Проведение торжественных мероприятий'
                    },
                    {
                        label: 'Путешествие',
                        value: 'Путешествие'
                    },
                    {
                        label: 'Неотложные нужды',
                        value: 'Неотложные нужды'
                    }
                ]
            }
        },
        methods: {
            makeCredit: function () {
                let _this = this;
                let data = new URLSearchParams();
                data.append('amount', this.amount);
                data.append('term', this.term);
                data.append('purpose', this.purpose);
                data.append('calculationType', this.creditType);
                data.append('creditProduct.id', this.productID);

                this.$http.post('/json/credit', data).then(
                    response => {
                        if( response.data.code === 0 ){
                            this.creditID = response.data.data;
                            Raven.captureMessage('Step end: '+_this.$options.name, {
                                level: 'info'
                            });
                            _this.$router.push({name: 'Obtaining'})

                        }else{
                            console.log(response);
                        }
                    },
                    response => {
                        console.log(response);
                    }
                )
            }
        },
        computed: {
            purposeLabel: function(){
                return this.purpose === '' ? '' : 'Цель займа';
            },
            formatAmount: function () {
                return this.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            },
            formatTerm: function () {
                let date = moment().add(this.term, 'months').format("DD.MM.YYYY");
                return this.term + ' ' + Helpers.declension(['месяц', 'месяца', 'месяцев'], this.term)+' ('+date+')';
            },
            ...creditFields([
               'creditID',
            ]),
            ...calculatorFields([
                'amount',
                'amountExternalStatus',
                'amountExternalError',

                'term',
                'termExternalStatus',
                'termExternalError',

                'creditType',
                'creditTypeExternalStatus',
                'creditTypeExternalError',

                'purpose',
                'purposeExternalStatus',
                'purposeExternalError',

                'productID'
            ]),
        },
        beforeCreate(){
            if( !this.$store.getters['profile/isInited'] ){
                this.$store.dispatch('profile/INIT');
            }
        },
        mounted() {
            this.$store.commit('CHANGE_PROGRESS', {progressBarShow: true, currentPercent: 70, nextPercent: 10});
        }
    }
</script>

<style lang="scss">

</style>